define('responsive-gameday/views/render/LinescoreViewRender',['require','exports','module','./ViewRender','Wax/get!view-templates/linescore/linescore','Wax/get!view-templates/linescore/embeddedLinescore','Wax/get!view-templates/linescore/activeInning','Wax/get!view-templates/linescore/bases','Wax/get!view-templates/linescore/midInning','Wax/get!view-templates/linescore/pitchingDecisions','Wax/get!view-templates/linescore/jingle'],function(require,exports,module){
    var ViewRender = require('./ViewRender'),
        Superclass;

    function LinescoreViewRender(){
        Superclass.constructor.call(this,
            require('Wax/get!view-templates/linescore/linescore'),{
                embeddedLinescoreView   : require( 'Wax/get!view-templates/linescore/embeddedLinescore' ),
                // embeddedLinescoreNewView: require( 'Wax/get!view-templates/linescore/embeddedLinescoreNew' ),
                activeInningView        : require( 'Wax/get!view-templates/linescore/activeInning' ),
                basesView               : require( 'Wax/get!view-templates/linescore/bases' ),
                midInningView           : require( 'Wax/get!view-templates/linescore/midInning' ),
                pitchingDecisionsView   : require( 'Wax/get!view-templates/linescore/pitchingDecisions' ),
                jingleView              : require( 'Wax/get!view-templates/linescore/jingle' )
            }
        );
    }
    ViewRender.spawn(LinescoreViewRender);

    Superclass=LinescoreViewRender.superclass;

    return LinescoreViewRender;
});
